import type { JSX } from 'react';

import { Text } from 'Components/Text/Text';

export interface ThirdPartyLocationProps {
    variant: 'dashboard' | 'nonDashboard';
    thirdPartyMetadata: {
        country: string;
        state?: string;
        city?: string;
        address_line_1?: string;
        address_line_2?: string;
        zip_code?: string;
    };
}

const line = (text: string | undefined): JSX.Element => {
    return text ? (
        <>
            {text}
            <br />
        </>
    ) : (
        <></>
    );
};

export const ThirdPartyLocation = (props: ThirdPartyLocationProps): JSX.Element => {
    const stateCityZip = (() => {
        let text = undefined;
        if (props.thirdPartyMetadata.city && props.thirdPartyMetadata.state) {
            text = props.thirdPartyMetadata.zip_code ? `${props.thirdPartyMetadata.city}, ${props.thirdPartyMetadata.state} ${props.thirdPartyMetadata.zip_code}` : `${props.thirdPartyMetadata.city}, ${props.thirdPartyMetadata.state}`;
        } else if (props.thirdPartyMetadata.city) {
            text = props.thirdPartyMetadata.city;
        } else if (props.thirdPartyMetadata.state) {
            text = props.thirdPartyMetadata.state;
        } else {
            text = undefined;
        }

        return line(text);
    })();

    const country = line(props.thirdPartyMetadata.country);

    return (
        <Text variant={props.variant === 'dashboard' ? 'Text2' : undefined} color={props.variant === 'dashboard' ? 'white' : 'blue'}>
            {stateCityZip}
            {country}
        </Text>
    );
};
